module.exports = __webpack_public_path__ + "static/media/acc-logo-white@2x.2504c653.png";